import { useQuery } from '@tanstack/react-query';

import { getConfiguration } from './configuration';

export const CONFIGURATION_KEY = 'Configuration';

export const useGetConfiguration = () => {
  return useQuery({
    queryKey: [CONFIGURATION_KEY],
    queryFn: getConfiguration,
  });
};
